import React, { useEffect } from "react";
import { connect } from "react-redux";
import { injectIntl } from "react-intl";
import Typography from "@material-ui/core/Typography";
import Grid from "@material-ui/core/Grid";
import useTheme from "@material-ui/core/styles/useTheme";
import { compose } from "recompose";
import Button from "@material-ui/core/Button";
import { reduxForm, formValueSelector } from "redux-form";
import {
  isCreatingProtocolSelector,
  isSavingSelector,
  bundleSelector,
} from "../../../redux/selectors";
import FormTextField from "../../../components/FormTextField";
import { required } from "../../../utilities/validators";
import { editBundle, startSaving, stopSaving } from "../../../redux/actions";
const requiredValidator = required;
const selector = formValueSelector("editBundle");

const EditBundleModal = ({
  intl,
  handleSubmit,
  edit,
  isSaving,
  name,
  startSaving,
}) => {
  const theme = useTheme();

  const onSubmitForm = (values) => {
    startSaving();
    edit(values.id, values.name, null, values.description);
  };

  useEffect(() => {}, []);

  return (
    <form onSubmit={handleSubmit(onSubmitForm)}>
      <Grid
        container
        direction="column"
        justify="flex-start"
        alignItems="center"
        style={{
          width: "75rem",
          padding: "4rem",
          margin: "auto",
          backgroundColor: theme.palette.secondary.main,
        }}
      >
        <Grid item style={{ alignSelf: "center" }}>
          <Typography
            variant="h1"
            style={{
              color: "#fff",
              marginBottom: "25px",
            }}
          >
            {intl.formatMessage({ id: "app.bundle.editBundleModalTitle" })}
          </Typography>
        </Grid>
        <Grid item style={{ alignSelf: "flex-start", width: "100%" }}>
          <FormTextField
            label={
              intl.formatMessage({ id: "app.bundle.bundleNamePlaceholder" }) +
              "*"
            }
            fullWidth
            type="text"
            name="name"
            maxLength={254}
            validators={[requiredValidator]}
            variant="filled"
          />
        </Grid>
        {/* <Grid item style={{ alignSelf: 'flex-start', width: '100%' }}>
					<FormTextField
						label={intl.formatMessage({ id: 'app.bundle.bundleTagNamePlaceholder' }) + '*'}
						fullWidth
						type="text"
						name="tagName"
						maxLength={254}
						validators={[ requiredValidator ]}
						variant="filled"
					/>
				</Grid> */}
        {/* <Grid item style={{ alignSelf: 'flex-start', width: '100%' }}>
					<FormTextField
						label={`${intl.formatMessage({
							id: 'app.bundle.bundleDescriptionPlaceholder'
						})} ${name}`}
						fullWidth
						type="text"
						name="description"
						maxLength={2047}
						multiline
						rows="3"
						variant="filled"
					/>
				</Grid> */}
        <Grid item>
          <Button
            label={intl.formatMessage({ id: "app.bundle.editButtonLabel" })}
            style={{
              width: "267px",
              marginTop: "40px",
            }}
            disabled={isSaving}
            type="submit"
            variant="contained"
            color="primary"
          >
            {intl.formatMessage({ id: "app.bundle.editButtonLabel" })}
          </Button>
        </Grid>
      </Grid>
    </form>
  );
};

const mapStateToProps = (state, ownProps) => ({
  isSaving: isSavingSelector(state),
  initialValues: bundleSelector(state),
  name: selector(state, "name"),
});

const mapDispatchToProps = (dispatch, ownProps) => ({
  edit: (id, name, tag, description) =>
    dispatch(editBundle(id, name, tag, description)),
  startSaving: () => dispatch(startSaving()),
});

const enhance = compose(
  connect(mapStateToProps, mapDispatchToProps),
  injectIntl,
  reduxForm({
    form: "editBundle",
    touchOnChange: true,
    touchOnBlur: true,
  }),
);

export default enhance(EditBundleModal);
